import { Context } from "@nuxt/types/app";
import formatCurrency from "format-currency";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  function numberToPriceFormat(value: number, locale = "id"): string {
    const valueToString = value.toString();
    const formatted = formatCurrency(valueToString, {
      symbol: "",
      format: "%s%v",
      locale: locale,
      nanZero: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return formatted;
  }

  return {
    numberToPriceFormat,
  };
}
